/** @format */

import { ActivatedRoute, Router } from '@angular/router';
import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChange
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {
	Environment,
	MyCustomizations,
	ProcessedNonBundleProduct
} from '@shared/data-access/interfaces';

@Component({
	selector: 'pdp-custom-components-product-customizer',
	templateUrl: './product-customizer.component.html',
	styleUrl: './product-customizer.component.scss',
	standalone: false
})
export class ProductCustomizerComponent implements OnInit, OnChanges {
	@Input() product: ProcessedNonBundleProduct;
	@Input() productDesignId: string;
	@Input() isCustomizationSelected: boolean;
	@Input() productSku: string;
	@Input() isCustomSet: boolean;
	/**
	 * @description
	 * The currently selected color attribute value if applicable
	 *
	 */
	@Input() selectedColorAttribute: string;

	@Output() panelClosed = new EventEmitter<MyCustomizations>();
	public safeCustomizerBaseURL;
	public customizerURL: SafeResourceUrl;
	public customizedAttributes: { name: string; value: string }[];
	public customizedUrls: string[];
	public isScene7url: boolean;
	public customizedImageSrc: string;
	public customizationData: MyCustomizations;
	public designURL: string;

	constructor(
		private environment: Environment,
		public route: ActivatedRoute,
		public router: Router,
		public sanitizer: DomSanitizer
	) {}

	ngOnInit() {
		if (this.productDesignId !== null && this.productDesignId !== undefined) {
			this.customizerURL = this.sanitizeURL(
				`${this.environment.customizer}/design/${this.productDesignId}/customize`
			);
		} else {
			if (this.isCustomSet) {
				this.customizerURL = this.sanitizeURL(
					`${this.environment.customizer}/${this.product.partNumber}`
				);
			} else {
				this.customizerURL = this.sanitizeURL(
					`${this.environment.customizer}/${this.productSku}`
				);
			}
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
		if (this.productDesignId !== null && this.productDesignId !== undefined) {
			this.customizerURL = this.sanitizeURL(
				`${this.environment.customizer}/design/${this.productDesignId}/customize`
			);
		} else {
			const productIdentifier = this.product.partNumber;
			this.customizerURL = this.sanitizeURL(
				`${this.environment.customizer}/${this.isCustomSet ? productIdentifier : this.productSku}`
			);
		}
	}

	@HostListener('window:message', ['$event'])
	onCustomizerSubmission(event: MessageEvent) {
		if (
			event.origin !== this.environment.customizer ||
			event.data.eventId !== 'mczrSaveDesign'
		) {
			return;
		}

		// displays the users choices on the page
		this.customizedAttributes = [];
		// sets to true to display the choices they made
		this.isCustomizationSelected = true;
		// setting image urls
		this.customizedUrls = event.data.summary.imageURLs;
		this.isScene7url = false;
		// sets the image to display of the customized item
		this.customizedImageSrc = event.data.summary.imageURLs[1];
		// sets the design url so the user can edit customization
		this.designURL = event.data.summary.designId;

		const routeQueryParams = {
			designId: this.designURL
		};

		if (this.selectedColorAttribute) {
			routeQueryParams['color'] = this.selectedColorAttribute;
		}
		this.router.navigate([], {
			// changes the route without moving from the current view or triggering a navigation event
			relativeTo: this.route,
			queryParams: routeQueryParams,
			// preserve the existing query params in the route
			queryParamsHandling: 'merge'
		});
		// sets data structure to pass into cart
		this.customizationData = {
			MyCustomizerMap: {
				designId: event.data.summary.designId,
				imageURLs: [event.data.summary.imageURLs[0], event.data.summary.imageURLs[1]],
				data: {},
				vendor: {},
				sku: {},
				totalPrice: event.data.summary.totalPrice
			}
		};

		// sets the data elements that need passed to cart
		const dataObject = event.data.summary.data;
		const dataArray = Object.entries(dataObject);
		const dataCartJSON = {};
		dataArray.forEach((arrayItem: [string, string]) => {
			// pushing elements to display to user
			this.customizedAttributes.push({ name: arrayItem[0], value: arrayItem[1] });
			dataCartJSON[arrayItem[0]] = arrayItem[1];
		});
		this.customizationData.MyCustomizerMap.data = dataCartJSON;

		// sets the vendor objects that need passed to cart
		const vendorObject = event.data.summary.vendor;
		const vendorArray = Object.entries(vendorObject);
		const vendorCartJSON = {};
		vendorArray.forEach((arrayItem) => {
			vendorCartJSON[arrayItem[0]] = arrayItem[1];
		});
		this.customizationData.MyCustomizerMap.vendor = vendorCartJSON;

		if (this.isCustomSet && event.data.summary.sku !== undefined) {
			const SkuObject = event.data.summary.sku;
			const skuArray = Object.entries(SkuObject);
			const skuCartJSON = {};

			skuArray.forEach((arrayItem) => {
				// pushing elements to display to user
				skuCartJSON[arrayItem[0]] = arrayItem[1];
			});
			this.customizationData.MyCustomizerMap.sku = skuCartJSON;
		}
		this.panelClosed.emit(this.customizationData);
	}

	private sanitizeURL(url: string) {
		if (this.productSku !== undefined) {
			return this.sanitizer.bypassSecurityTrustResourceUrl(url);
		}
	}
}
